//const Apiurl = "http://192.168.1.36:8001/api";
// const Apiurl = "http://192.168.1.36:8001/api";

 const Apiurl = "https://bs.aalantechsoft.com:8031/api";
// const Apiurl = `http://${window.location.hostname}:8000/api`;

export default Apiurl;
